// src/components/icons.jsx
//
// Cztery ikony, których używa serwis, jako zwykłe SVG.
//
// Wcześniej brały się z `react-icons`. Paczka nie daje się otrząsnąć
// (tree-shaking) w konfiguracji CRA: import dwóch ikon z `react-icons/fa`
// wciągał do main.js ~600 kB źródeł całego zestawu. Ikony to w praktyce
// kilka ścieżek SVG, więc trzymamy je u siebie - API (size, color, style)
// zostawiamy takie samo, żeby nie ruszać komponentów.

import React from 'react';

const Svg = ({ viewBox, size, color, style, children, ...rest }) => (
  <svg
    viewBox={viewBox}
    height={size || '1em'}
    width={size || '1em'}
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0"
    xmlns="http://www.w3.org/2000/svg"
    style={color ? { color, ...style } : style}
    {...rest}
  >
    {children}
  </svg>
);

export const FaUser = props => (
  <Svg viewBox="0 0 448 512" {...props}>
    <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" />
  </Svg>
);

export const FaCircle = props => (
  <Svg viewBox="0 0 512 512" {...props}>
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" />
  </Svg>
);

export const IoMdClose = props => (
  <Svg viewBox="0 0 512 512" {...props}>
    <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z" />
  </Svg>
);

export const FiMenu = ({ size, color, style, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    height={size || '1em'}
    width={size || '1em'}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    style={color ? { color, ...style } : style}
    {...rest}
  >
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

/* Strzałka odświeżania - zastępuje emoji 🔄, które w części przeglądarek
   renderowało się jako pusty prostokąt (brak kroju z emoji na serwerze). */
export const FiRefresh = ({ size = 18, ...rest }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor"
       strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
    <path d="M21 12a9 9 0 1 1-2.64-6.36" />
    <polyline points="21 3 21 9 15 9" />
  </svg>
);
